"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataKeyHelper = exports.MetadataKey = void 0;
const symbol_sdk_1 = require("symbol-sdk");
var MetadataKey;
(function (MetadataKey) {
    MetadataKey["author"] = "B8A2B7186A421369";
    MetadataKey["title"] = "A801BEEB799108BC";
    MetadataKey["tag"] = "EB9BDBED96B9EC45";
    MetadataKey["description"] = "9E30087F94867CF9";
    MetadataKey["filename"] = "D298EBA89C34461D";
    MetadataKey["originUrl"] = "9FA2FCC0B88961FC";
    MetadataKey["certificateUrl"] = "92F13A7B7DF2F7A9";
})(MetadataKey = exports.MetadataKey || (exports.MetadataKey = {}));
class MetadataKeyHelper {
    static getKeyNameByKeyId(keyId) {
        switch (keyId.toHex()) {
            case MetadataKey.author:
                return 'Author';
            case MetadataKey.title:
                return 'Title';
            case MetadataKey.tag:
                return 'Tag';
            case MetadataKey.description:
                return 'Description';
            case MetadataKey.originUrl:
                return 'OriginUrl';
            case MetadataKey.certificateUrl:
                return 'CertificateUrl';
            case MetadataKey.filename:
                return 'Filename';
            default:
                return keyId.toHex();
        }
    }
    static keyToKeyId(key) {
        return symbol_sdk_1.KeyGenerator.generateUInt64Key(key);
    }
}
exports.MetadataKeyHelper = MetadataKeyHelper;
//# sourceMappingURL=MetadataKeyHelper.js.map